import { Injectable } from '@angular/core';
import { DELIVERY_FEATURE_LAZY, DeliveryDate } from '@delivery/const';
import { StateUtils, facadeFactory } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: DeliveryDateService,
      feature: DELIVERY_FEATURE_LAZY,
      methods: [
        'getDeliveryDate',
        'getContextUpdate',
        'getDeliveryDateError',
        'getDeliveryDateLoading',
        'getDeliveryDateNotAvailable',
        'getDeliveryDateState',
        'getDeliveryDateSuccess',
        'loadDeliveryDate',
      ],
      async: true,
    }),
})
export abstract class DeliveryDateService {
  abstract getDeliveryDate(): Observable<DeliveryDate>;
  abstract getDeliveryDateLoading(): Observable<boolean>;
  abstract getDeliveryDateError(): Observable<boolean>;
  abstract getDeliveryDateSuccess(): Observable<boolean>;
  abstract getDeliveryDateState(): Observable<StateUtils.LoaderState<DeliveryDate>>;
  abstract getDeliveryDateNotAvailable(): Observable<boolean>;
  abstract loadDeliveryDate(): void;
  abstract getContextUpdate(): Observable<void>;
}
